// PageContainer.jsx
import React, { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import { Box } from "@mui/material";

const PageContainer = ({ children, withSidebar = true }) => {
  const location = useLocation();
  useLayoutEffect(() => {
    // Only scroll to top if there's no hash in the URL
    if (!location.hash) {
      // Force scroll to top immediately when PageContainer mounts or route changes
      window.scrollTo(0, 0);

      // Also reset any scrollable containers
      const scrollableContainers = document.querySelectorAll(
        '[style*="overflow"]'
      );
      scrollableContainers.forEach((container) => {
        if (container.scrollTo) {
          container.scrollTo(0, 0);
        }
      });
    }
  }, [location.pathname]);
  return (
    <Box
      className="page-container"
      sx={{
        // Base margin is 1rem on mobile, 2rem on slightly larger screens
        // margin: { xs: "1rem", sm: "2rem" },
        // If withSidebar is true, apply a left margin at md and up for sidebar space
        marginLeft: withSidebar ? { xs: "0px", md: "260px" } : { xs: "0px" },
        flexGrow: 1,
      }}
    >
      {children}
    </Box>
  );
};

export default PageContainer;
